<ngx-ui-loader text="{{ 'Message.Loading' | translate }}"
               fgsType="folding-cube"
               fgsColor="#3f51b5"></ngx-ui-loader>
<mat-sidenav-container fullscreen [class.m2app-dark]="selectedthem ===1"
                       [class.m2app-pink]="selectedthem ===2"
                       [dir]="share.sharemodel.isrtl ? 'rtl':'ltr' "
                       class="customcontainer" *ngIf="this.share.setting">

    <div class="app-content total" [class.total]="share.sharemodel.isrtl">
        <div id="TEST_VERSION" *ngIf="isTestScreen" (click)="isTestScreen = !isTestScreen">این نسخه دیجیتال منو برای تست است</div>
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-container>
 